import { deleteRequest, getRequest, patchRequest, postRequest } from "../utils/axios";

function apiGet(url) {
  return getRequest(url, (response) => response.data);
}

function apiPost(url, data) {
  return postRequest(url, data, (response) => response.data);
}

function apiPatch(url, data) {
  return patchRequest(url, data, (response) => response.data);
}

function getJson(url) {
  return apiGet(url);
}

function postJson(url, data) {
  return apiPost(url, data);
}

function patchJson(url, data) {
  return apiPatch(url, data);
}

function apiDelete(url) {
  return deleteRequest(url, (response) => response.data);
}

function deleteJson(url) {
  return apiDelete(url);
}

export {
  apiGet,
  apiPatch,
  apiPost,
  deleteJson,
  getJson,
  getJson as getJSON,
  patchJson,
  patchJson as patchJSON,
  postJson,
  postJson as postJSON,
};
